module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxLjUiPjxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoMzB2MzBIMHoiLz48cGF0aCBkPSJNMSAxbDI4IDI4bTAtMjhMMSAyOSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ../assets/cross.svg
// module id = 410
// module chunks = 0